import React from "react";
import {PageHeader} from "./PageHeader";
import {Link} from "react-router-dom";
import album1 from '../img/album-d1.png';
import album2 from '../img/album-d2.png';
import album3 from '../img/album-d3.png';
import album3k from '../img/album-d3k.png';
import album4 from '../img/album-d4.png';
import album4b from '../img/album-d4b.png';
import album5 from '../img/album-d5.png';
import album6 from '../img/album-d6.png';

export const Gallery = props => {
    return (
        <React.Fragment>
            <PageHeader title="Galeria"/>
            <div className="content-wrapper">
                <div className="main-content page-gallery page-gallery-albums">
                    <div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-1"}>
                                <img src={album1} alt="Piątek, 13/09"/>
                                <span>Piątek, 13/09</span>
                            </Link>
                        </div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-2"}>
                                <img src={album2} alt="Sobota, 14/09"/>
                                <span>Sobota, 14/09</span>
                            </Link>
                        </div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-3"}>
                                <img src={album3} alt="Niedziela, 15/09"/>
                                <span>Niedziela, 15/09</span>
                            </Link>
                        </div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-3-concert"}>
                                <img src={album3k} alt="Niedziela, 15/09 - Widowisko multimedialne"/>
                                <span>Niedziela, 15/09 - Widowisko multimedialne</span>
                            </Link>
                        </div>
                    </div>
                    <div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-4"}>
                                <img src={album4} alt="Poniedziałek, 16/09"/>
                                <span>Poniedziałek, 16/09</span>
                            </Link>
                        </div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-4-banquet"}>
                                <img src={album4b} alt="Poniedziałek, 16/09 - Bakiet"/>
                                <span>Poniedziałek, 16/09 - Bakiet</span>
                            </Link>
                        </div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-5"}>
                                <img src={album5} alt="Wtorek, 17/09"/>
                                <span>Wtorek, 17/09</span>
                            </Link>
                        </div>
                        <div>
                            <Link to={"/po-zjezdzie/galeria/day-6"}>
                                <img src={album6} alt="Środa, 18/09"/>
                                <span>Środa, 18/09</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

Gallery.propTypes = {};
